import React from 'react';
export function Footer() {
  return <footer className="bg-charcoal-900 text-white pt-24 pb-12 px-6 md:px-12" data-id="element-9">
      <div className="max-w-7xl mx-auto" data-id="element-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-24" data-id="element-11">
          <div className="col-span-1 md:col-span-2" data-id="element-12">
            <h2 className="text-2xl font-bold tracking-widest uppercase mb-6" data-id="element-13">
              Aura
            </h2>
            <p className="text-charcoal-400 max-w-sm text-lg font-light leading-relaxed" data-id="element-14">
              The premier destination for discovering and acquiring
              extraordinary real estate worldwide.
            </p>
          </div>

          <div data-id="element-15">
            <h3 className="text-sm font-bold tracking-widest uppercase mb-6 text-charcoal-500" data-id="element-16">
              Explore
            </h3>
            <ul className="space-y-4 text-charcoal-300" data-id="element-17">
              <li data-id="element-18">
                <a href="#" className="hover:text-white transition-colors" data-id="element-19">
                  Buy
                </a>
              </li>
              <li data-id="element-20">
                <a href="#" className="hover:text-white transition-colors" data-id="element-21">
                  Sell
                </a>
              </li>
              <li data-id="element-22">
                <a href="#" className="hover:text-white transition-colors" data-id="element-23">
                  Off-Market
                </a>
              </li>
              <li data-id="element-24">
                <a href="#" className="hover:text-white transition-colors" data-id="element-25">
                  New Developments
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-26">
            <h3 className="text-sm font-bold tracking-widest uppercase mb-6 text-charcoal-500" data-id="element-27">
              Company
            </h3>
            <ul className="space-y-4 text-charcoal-300" data-id="element-28">
              <li data-id="element-29">
                <a href="#" className="hover:text-white transition-colors" data-id="element-30">
                  About Us
                </a>
              </li>
              <li data-id="element-31">
                <a href="#" className="hover:text-white transition-colors" data-id="element-32">
                  Private Advisors
                </a>
              </li>
              <li data-id="element-33">
                <a href="#" className="hover:text-white transition-colors" data-id="element-34">
                  Press
                </a>
              </li>
              <li data-id="element-35">
                <a href="#" className="hover:text-white transition-colors" data-id="element-36">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-charcoal-800 flex flex-col md:flex-row items-center justify-between gap-4 text-charcoal-500 text-sm" data-id="element-37">
          <p data-id="element-38">
            © {new Date().getFullYear()} Aura Estates. All rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-39">
            <a href="#" className="hover:text-white transition-colors" data-id="element-40">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-41">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}